import React from 'react';
import SensorDashboard from './pages/SensorDashboard';

function App() {
  return (
    <div>
      <SensorDashboard />
    </div>
  );
}

export default App;
